import clsx from 'clsx';

const Price = ({
  amount,
  className,
  currencyCode = 'XOF',
  currencyCodeClassName
}: {
  amount: string;
  className?: string;
  currencyCode: string;
  currencyCodeClassName?: string;
} & React.ComponentProps<'p'>) => {
  // Format XOF (Franc CFA) manually since Intl.NumberFormat doesn't handle it well
  if (currencyCode === 'XOF') {
    const formattedAmount = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(parseFloat(amount));
    
    return (
      <p suppressHydrationWarning={true} className={className}>
        {`${formattedAmount} F CFA`}
      </p>
    );
  }

  // EUR : 550,00 € (2 décimales, symbole €)
  if (currencyCode === 'EUR') {
    const formatted = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(amount));
    return (
      <p suppressHydrationWarning={true} className={className}>
        {`${formatted} €`}
      </p>
    );
  }

  // Autres devises : format standard
  return (
    <p suppressHydrationWarning={true} className={className}>
      {`${new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
      }).format(parseFloat(amount))}`}
      <span className={clsx('ml-1 inline', currencyCodeClassName)}>{`${currencyCode}`}</span>
    </p>
  );
};

export default Price;



